<template>
  <div>
    <v-alert-dialog ref="alert"></v-alert-dialog>

    <!-- LOADING -->
    <div v-if="loading" class="pa-0 ma-0">
      <v-progress-linear
        indeterminate
        height="6"
        rounded
      />
    </div>

    <!-- TEXTO -->
    <div v-else class="pa-0 ma-0">
      <span v-if="resolvedText && resolvedText.length > 0">
        {{ resolvedText }}
      </span>
      <span v-else class="grey--text text--darken-1">
        —
      </span>
    </div>
  </div>
</template>

<script>
import VAlertDialog from '@/components/VAlertDialog.vue'
import axios from 'axios'

export default {
  name: 'VAutocompleteText',
  components: { VAlertDialog },
  props: {
    value: {
      // el v-model (id/valor)
      type: [String, Number],
      default: null
    },
    urlGet: {
      type: String,
      default: ''
    },
    itemValue: {
      type: String,
      default: ''
    },
    itemText: {
      type: String,
      default: 'nombre'
    }
  },
  data: () => ({
    loading: false,
    elementos: [],
    resolvedText: null,

    // Fix: valor llega antes que items
    pendingValue: null,
  }),
  watch: {
    value: {
      immediate: true,
      handler(newValue) {
        // Si aún no hay elementos, guardamos el valor pendiente y resolvemos cuando cargue
        if (!this.elementos || this.elementos.length === 0) {
          this.pendingValue = newValue;
          return;
        }
        this.resolveTextFromValue(newValue);
      }
    },
    urlGet: {
      immediate: true,
      handler() {
        this.getElementos();
      }
    }
  },
  methods: {
    getElementos() {
      if (!this.urlGet || this.urlGet.length === 0) {
        this.elementos = [];
        this.resolvedText = null;
        return;
      }

      this.loading = true;
      axios
        .get(this.urlGet)
        .then(response => {
          this.elementos = response.data || [];

          // Si había un valor pendiente, lo resolvemos ahora
          const v = (this.pendingValue !== null && typeof this.pendingValue !== 'undefined')
            ? this.pendingValue
            : this.value;

          this.pendingValue = null;

          this.resolveTextFromValue(v);
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        })
    },

    resolveTextFromValue(v) {
      if (v === null || typeof v === 'undefined' || v === '') {
        this.resolvedText = null;
        return;
      }

      // Encuentra el item cuyo itemValue == v
      const item = this.elementos.find(x => {
        if (!x) return false;
        // comparación flexible (por si viene string/number)
        return String(x[this.itemValue]) === String(v);
      });

      this.resolvedText = item ? (item[this.itemText] ?? null) : null;
    },

    // Soporta v-model por consistencia, por si alguien lo usa con @input
    updateValue(val) {
      this.$emit('input', val);
    }
  }
}
</script>
